export const resolveSidebarRequestLogProvider = ({
  provider,
  providerId,
  providers,
}: {
  provider?: string | null;
  providerId?: number | null;
  providers?: { id: number; name: string }[];
}) => providers?.find(candidate => candidate.id === providerId)?.name ?? provider;
